import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=A%20clean%20and%20fresh%20lifestyle%20flat%20lay%20of%20modern%20streetwear%20fashion%20products%20including%20white%20sneakers%2C%20folded%20hoodies%2C%20t-shirts%2C%20caps%20and%20small%20accessories%20arranged%20neatly%20on%20a%20soft%20warm%20cream%20surface%20with%20gentle%20natural%20daylight%2C%20minimal%20pastel%20styling%20with%20subtle%20sage%20green%20and%20warm%20amber%20tones%2C%20airy%20editorial%20product%20photography%2C%20soft%20diffused%20shadows%2C%20bright%20and%20calm%20composition%2C%20high%20detail%2C%20harmonious%20organized%20arrangement&width=1600&height=900&seq=usfans-hero-1&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45" />

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-28 text-center md:px-6 md:py-36">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur">
          <span className="flex h-3.5 w-3.5 items-center justify-center text-xs text-emerald-300">
            <i className="ri-shield-check-line"></i>
          </span>
          {t('hero.badge')}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-extrabold leading-tight text-white md:text-5xl">
          {t('hero.title')}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex w-full flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-emerald-500 px-6 py-3.5 text-base font-semibold text-white transition-colors hover:bg-emerald-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center text-lg">
              <i className="ri-external-link-line"></i>
            </span>
            {t('nav.openSpreadsheet')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-amber-500 px-6 py-3.5 text-base font-semibold text-white transition-colors hover:bg-amber-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center text-lg">
              <i className="ri-shopping-bag-3-line"></i>
            </span>
            {t('cta.buyNow')}
          </a>
        </div>

        <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/article"
            className="whitespace-nowrap text-sm font-medium text-white/90 underline-offset-4 transition-colors hover:text-white hover:underline"
          >
            {t('cta.readArticle')} →
          </Link>
          <span className="hidden text-white/40 sm:inline">·</span>
          <a
            href="#categories"
            className="whitespace-nowrap text-sm font-medium text-white/90 underline-offset-4 transition-colors hover:text-white hover:underline"
          >
            {t('nav.categories')} ↓
          </a>
        </div>
      </div>
    </section>
  );
}